import React from 'react';
import { AlertsTable, } from './AlertsTable';

const Alerts = () => <AlertsTable/>;

export { Alerts, };
